import { View } from 'react-native';

import { FloatingViewCartFab } from 'components/floating-view-cart-fab';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { MenuSection } from 'pages/menu/menu-object-page/menu-section';
import { MenuSectionPage } from 'pages/menu/menu-section-page/menu-section-page';
import { useStoreRequired } from 'state/store/hooks/use-store-required';

export default function MenuSectionPageById() {
  useStoreRequired();

  const enableUnifiedMenu = useEnableUnifiedMenu();

  return (
    <View testID="menu-section-page" style={{ flex: 1 }}>
      {enableUnifiedMenu ? <MenuSectionPage /> : <MenuSection />}
      <FloatingViewCartFab />
    </View>
  );
}
